/**
 * Velora – gedeeld gedrag voor de hele winkel.
 *
 * 1. Accordeons: elke <details> binnen .accordion (Horizon accordion-blok), .vl-faq of een element
 *    met [data-vl-accordion] opent en sluit soepel, en er staat er per groep maar één open.
 *    Nieuwe uitklapbare onderdelen? Zet ze in een container met data-vl-accordion en het werkt vanzelf.
 * 2. Knoppen (.vl-btn) die naar het product van de huidige pagina linken, scrollen soepel naar de
 *    bundelkeuze in plaats van de pagina opnieuw te laden.
 *
 * De standaard geselecteerde bundel wordt NIET hier geregeld maar door Shopify zelf: de variant op
 * positie 1 is bij het laden al gekozen (zie blocks/velora-bundles.liquid).
 */
(() => {
  const ACCORDION_GROUPS = '.accordion, .vl-faq, [data-vl-accordion]';
  const DURATION = 320;
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** @type {WeakMap<HTMLDetailsElement, Animation>} */
  const running = new WeakMap();

  function summaryHeight(details) {
    const summary = details.querySelector(':scope > summary');
    return summary ? summary.offsetHeight : 0;
  }

  function animateHeight(details, from, to, onFinish) {
    running.get(details)?.cancel();
    if (reducedMotion.matches) {
      onFinish?.();
      return;
    }
    details.style.overflow = 'hidden';
    const animation = details.animate({ height: [`${from}px`, `${to}px`] }, { duration: DURATION, easing: EASING });
    running.set(details, animation);
    animation.onfinish = () => {
      running.delete(details);
      details.style.overflow = '';
      onFinish?.();
    };
    animation.oncancel = () => {
      running.delete(details);
      details.style.overflow = '';
    };
  }

  function openDetails(details) {
    const start = details.offsetHeight;
    running.get(details)?.cancel();
    delete details.dataset.vlClosing;
    details.open = true;
    animateHeight(details, start, details.offsetHeight);
  }

  function closeDetails(details) {
    if (!details.open || details.dataset.vlClosing) return;
    details.dataset.vlClosing = 'true';
    animateHeight(details, details.offsetHeight, summaryHeight(details), () => {
      details.open = false;
      delete details.dataset.vlClosing;
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element ? event.target.closest('summary') : null;
    if (!summary) return;
    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement)) return;
    const group = details.closest(ACCORDION_GROUPS);
    if (!group) return;

    event.preventDefault();

    if (details.open && !details.dataset.vlClosing) {
      closeDetails(details);
      return;
    }

    // Andere open items in dezelfde groep sluiten (niet die in geneste groepen)
    group.querySelectorAll('details[open]').forEach((other) => {
      if (other !== details && other.closest(ACCORDION_GROUPS) === group) closeDetails(other);
    });
    openDetails(details);
  });

  /* ---------- Soepel scrollen naar de bundelkeuze ---------- */
  function lastSegment(path) {
    return path.replace(/\/+$/, '').split('/').pop();
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a.vl-btn[href]') : null;
    if (!link) return;
    const bundles = document.querySelector('.vl-bundles');
    if (!bundles) return;

    const url = new URL(link.getAttribute('href'), window.location.href);
    const samePage =
      url.hash === '#bundels' ||
      (url.pathname.includes('/products/') && lastSegment(url.pathname) === lastSegment(window.location.pathname));
    if (!samePage) return;

    event.preventDefault();
    bundles.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
    bundles.classList.remove('vl-bundles--highlight');
    // Herstart de markering ook bij een tweede klik
    void bundles.offsetWidth;
    bundles.classList.add('vl-bundles--highlight');
  });
})();
